'use client';

import HeroBurgerIllustration from '@/app/illustrations/HeroBurgerIllustration';
import LeviButton from '@/app/components/LeviButton';
import { motion } from 'framer-motion';
import Animation from '@/app/components/Animation';

export default function HeroSection({ className = '' }: { className?: string }) {
  return (
    <div className={ `container ${ className }` }>
      <div className={ 'flex flex-col md:flex-row gap-16 items-center justify-between' }>
        <div className={ 'flex flex-col items-start gap-4 relative z-10' }>
          <div className={ 'mt-4' }>
            <motion.div className='h1'
                        initial={ { opacity: 0, y: 20 } }
                        animate={ { opacity: 1, y: 0 } }
                        transition={ { duration: 0.8 } }>
              SHOW
            </motion.div>
            <motion.div className={ 'text-leading-black max-w-[40rem]' }
                        initial={ { opacity: 0, y: 20 } }
                        animate={ { opacity: 1, y: 0 } }
                        transition={ { duration: 0.8, delay: 0.4 } }>
              <div className={'float-left'}>která vám naplní podnik</div>
            </motion.div>
          </div>
          <motion.div className={ 'max-w-[40rem] origin-left' }
                      initial={ { opacity: 0, y: 20 } }
                      animate={ { opacity: 1, y: 0 } }
                      transition={ { duration: 0.8, delay: 0.8 } }>Máte skvělý produkt a&nbsp;cítíte, že máte potenciál vydělat mnohem víc? Postaráme se, aby o&nbsp;vás lidé věděli a&nbsp;váš byznys
            rostl.
          </motion.div>
          <LeviButton href={ '#proc-s-nami' } color={ 'primary' }
                      initial={ { opacity: 0, scale: 0 } }
                      animate={ { opacity: 1, scale: 1 } }
                      transition={ { duration: 0.8, delay: 0.2, type: 'spring', damping: 12, stiffness: 200 } }>
            Proč s námi
          </LeviButton>
        </div>
        <motion.div className={ 'absolute md:relative hidden md:block' } initial={ { opacity: 0 } } animate={ { opacity: 1 } } transition={ { duration: 1, ease: 'easeOut', delay: 0.5 } }>
          <HeroBurgerIllustration className={ 'w-[90%] mx-auto md:mx-0 z-0 md:w-[572px]' } />
        </motion.div>
      </div>
    </div>
  );
}
